export const isValidAffiliateLink = (link, internalNote = '', system = 'myAffiliates') => {
    if (!link) return true; // Empty is valid until submitted

    // Reject URLs that start with @
    if (link.startsWith('@')) {
        return false;
    }

    try {
        // First check if it's a valid URL
        const url = new URL(link);

        // Ensure protocol is http or https
        if (url.protocol !== 'http:' && url.protocol !== 'https:') {
            return false;
        }

        // System-specific validation
        switch (system.toLowerCase()) {
            case 'myaffiliates':
                // For MyAffiliates, the URL should be:
                // https://somedomain.someextension/someid/somenumber
                // Check if the path has at least two segments and the last one is a number
                const pathParts = url.pathname.split('/').filter(part => part !== '');

                // Need at least two parts in the path
                if (pathParts.length < 2) {
                    return false;
                }

                // Last part must be a number
                const lastPart = pathParts[pathParts.length - 1];
                if (!isNaN(lastPart) && lastPart.trim() !== '') {
                    if (internalNote != '') {
                        return lastPart == internalNote;
                    }
                    else return true;
                }

            case 'referon': {
                // Example: https://domain.ext/?mid=xxxx_YYYYYY&pubid=YYYYYY&clickid={clickid}
                try {
                    const urlObj = new URL(link); // value is the link to validate

                    // Check for required params
                    const mid = urlObj.searchParams.get('mid');
                    const pubid = urlObj.searchParams.get('pubid');
                    const clickid = urlObj.searchParams.get('clickid');

                    // mid must exist and have an underscore
                    if (!mid || !mid.includes('_')) return false;

                    // pubid must exist
                    if (!pubid) return false;

                    // The part after the underscore in mid
                    const midSuffix = mid.split('_')[1];

                    // pubid must match midSuffix
                    if (pubid !== midSuffix) return false;

                    // If internalNote is provided, pubid must match it
                    if (internalNote && pubid !== internalNote) return false;

                    // clickid must be present (can be {clickid} or any value)
                    if (!clickid) return false;

                    return true;
                } catch (e) {
                    return false;
                }
            }
            case 'cellxpert': {
                // Example: https://go.afftrackio.com/visit/?bta=35375&nci=5356&afp=clickid&utm_campaign=src
                try {
                    const urlObj = new URL(link);

                    // Must have utm_campaign param
                    const utm_campaign = urlObj.searchParams.get('utm_campaign');

                    // Optionally, check for other required params (bta, nci, afp)
                    const bta = urlObj.searchParams.get('bta');
                    const nci = urlObj.searchParams.get('nci');
                    // const afp = urlObj.searchParams.get('afp');
                    if (!bta || !nci || !utm_campaign) return false;

                    if (internalNote != '' && utm_campaign != internalNote) return false;
                    return true;
                } catch (e) {
                    return false;
                }
            }
            case 'affise': {
                // Example: https://domain.ext/click?pid=XX&offer_id=YY&sub2=key&sub1={clickid}
                return !!url.searchParams.get('sub1');
            }
            case 'netrefer':
            case 'netrefer api': {
                // Example: https://domain.ext/redirect.aspx?pid=XX&lpid=YY&bid=ZZ&campaign=key&clickid={clickid}
                //      or: https://domain.ext/redirect.aspx?pid=XX&lpid=YY&bid=ZZ&subid=key-{clickid}
                if (!url.searchParams.get('pid')) return false;
                const subid = url.searchParams.get('subid');
                if (subid) return true;
                const campaign = url.searchParams.get('campaign');
                if (!campaign || !url.searchParams.get('clickid')) return false;
                if (internalNote != '' && campaign != internalNote) return false;
                return true;
            }
            default:
                // For unknown systems, just validate it's a URL (already done)
                return true;
        }
    } catch (e) {
        console.error(e);
        return false;
        // Invalid URL format
    }
    return false;

};

export const expectedAffiliateLinkFormat = (system = 'myAffiliates', internalNote = '') => {
    switch (system.toLowerCase()) {
        case 'myaffiliates': {
            let number = 'number';
            if (internalNote != '') {
                number = internalNote;
            }
            return 'https://domain.ext/_path/' + number;
        }
        case 'referon': {
            // Example: https://domain.ext/?mid=xxxx_YYYYYY&pubid=YYYYYY&clickid={clickid}
            let pubid = internalNote || 'pubid';
            return `https://domain.ext/?mid=xxxx_${pubid}&pubid=${pubid}&clickid={clickid}`;
        }
        case 'cellxpert': {
            let utm_campaign = internalNote || 'utm_campaign';
            // Example: https://go.afftrackio.com/visit/?bta=35375&nci=5356&afp=clickid&utm_campaign=src
            return `https://go.domain.ext/visit/?bta=XXXXX&nci=YYYYY&afp1={clickid}&utm_campaign=${utm_campaign}`;
        }
        case 'affise':
            return `https://domain.ext/click?pid=XX&offer_id=YY&sub2=${internalNote || 'key'}&sub1={clickid}`;
        case 'netrefer':
            return `https://domain.ext/redirect.aspx?pid=XX&lpid=YY&bid=ZZ&subid=${internalNote || 'key'}-{clickid}`;
        case 'netrefer api':
            return `https://domain.ext/redirect.aspx?pid=XX&lpid=YY&bid=ZZ&campaign=${internalNote || 'key'}&clickid={clickid}`;
        default:
            return 'Valid URL';
    }
}
